@if (notificationList.length>0) {
<div class="notification-accordion">
  <mat-accordion multi="true">
    @for (notification of notificationList; track notification; let i = $index) { @if
    (notification.Popup=='True'||notification.Popup=='true') {
    <mat-expansion-panel #panel class="prevent-click">
      <mat-expansion-panel-header>
        <mat-panel-title>
          @if (panel.expanded) {
          <mat-icon class="expansion-icon me-1 enable-click">keyboard_arrow_down</mat-icon>
          } @if (!panel.expanded) {
          <mat-icon class="expansion-icon me-1 enable-click">keyboard_arrow_right</mat-icon>
          }
          {{ notification.Content }}:
        </mat-panel-title>
      </mat-expansion-panel-header>
      @for (description of notification.notifications; track description) {
      <div class="notification-message enable-click" [innerHTML]="description.Notification_message | safeHtml"></div>
      }
    </mat-expansion-panel>
    } }
  </mat-accordion>
</div>
}
